module.exports = __webpack_public_path__ + "static/3-69669879cadd1f0f5f110ec9cf93fc94.jpg";